//import React from 'react';
import React, { useContext } from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import MatxCssVars from './MatxCssVars';
import useSettings from 'app/hooks/useSettings';
import { ShopContext } from "app/contexts/ShopContext";

// import cssVars from "css-vars-ponyfill";

const MatxTheme = ({ children }) => {
  const { settings } = useSettings();
  let activeTheme = { ...settings.themes[settings.activeTheme] };
  console.log(activeTheme);


  const { shops, setShops } = useContext(ShopContext)
  console.log('shopsを呼び出せるか', shops);
  
  // cssVars();
  // activeTheme.direction = settings.direction;
  return (
    <ThemeProvider theme={activeTheme}>
      <CssBaseline />
      <MatxCssVars> {children} </MatxCssVars>
    </ThemeProvider>
  );
};

export default MatxTheme;
